import PropTypes from 'prop-types';
import React from 'react';
import { FormGroup, Button, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import HotelList from './HotelList';
import WebHotelList from './WebHotelList';
import Loading from '../../../components/Loading';


class HotelAddDetail extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleAdvanceSearch = this.handleAdvanceSearch.bind(this);
    this.getDistance = this.getDistance.bind(this);
    this.formatSelectedHotel = this.formatSelectedHotel.bind(this);
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeRadius = this.handleChangeRadius.bind(this);
    this.hotelSearchByPlace = this.hotelSearchByPlace.bind(this);
    this.state = {
      search: this.props.search,
      save: false,
      isAdvanceSearch: false,
      hotelsListFromWeb: [],
      hotelListplace: [],
      isLoading: false,
      hotelPlaceFlag: false,
      searchBtnColor: this.props.hotels.length > 0 ? "success" : "default",
      searchFromWebBtnColor: "default",
      searchType: '',
      placeName: '',
      radiusInMeter:'',
      counterLength: 0,
      radiusType: '',
      searchfromDatabase:false,
    };

  }
  handleChange(e) {
    this.setState({
      search: e.target.value,
      save: true,
    });
  }

  handleChangeName(e) {
    this.setState({
      placeName: e.target.value
    });
  }

  handleChangeRadius(e) {
    this.setState({
      radiusInMeter: e.target.value
    });
  }

  //Function to calculate distance from two geo locations.
  getDistance(lat1, lon1, lat2, lon2, unit) {
    if ((lat1 == lat2) && (lon1 == lon2)) {
      return 0;
    }
    else {
      var radlat1 = Math.PI * lat1 / 180;
      var radlat2 = Math.PI * lat2 / 180;
      var theta = lon1 - lon2;
      var radtheta = Math.PI * theta / 180;
      var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      if (dist > 1) {
        dist = 1;
      }
      dist = Math.acos(dist);
      dist = dist * 180 / Math.PI;
      dist = dist * 60 * 1.1515;
      if (unit == "K") { dist = dist * 1.609344 }
      if (unit == "N") { dist = dist * 0.8684 }
      return dist;
    }
  }
  handleSearch() {

    let isValidSearchText = this.state.search ? this.state.search.trim() : this.state.search
    if (!isValidSearchText) {
      alert("Please enter search text");
      return
    }
    if (this.state.search.length > 2) {
      // this.setState({
      //   isAdvanceSearch: false
      // })
      if (this.state.search.length > 2) {
        console.log('Go search: ', this.state.search);
        this.props.findHotels(this.props.event.event.id, this.state.search);
        this.setState({
          searchBtnColor: "success",
          searchFromWebBtnColor: "default",
          searchfromDatabase: true
        })
      }
    }
  }
  handleAdvanceSearch() {
    let isValidSearchText = this.state.search ? this.state.search.trim() : this.state.search
    if (!isValidSearchText) {
      alert("Please enter search text");
      return
    }
    this.setState({
      isLoading: true,
      searchFromWebBtnColor: "success",
      searchBtnColor: "default"
    })

    let payload = {
      eventId: this.props.event.event.id,
      searchTerm: this.state.search
    }

    this.props.requestHotelAdvanceSearchWithPrefs(payload, (response) => {
      let hotelsData = response.results;
      let eventPosition = response.event_position;

      hotelsData.forEach((hotel) => {
        let hotelLocation = hotel.geometry.location;
        let distance = this.getDistance(eventPosition.lat, eventPosition.lng, hotelLocation.lat, hotelLocation.lng, "K")
        hotel['distance'] = distance;
        let existHotel = this.props.existingHotelsList.filter(function (exHotel) {
          return exHotel.google_place_id == hotel.place_id;

        });
        if (existHotel.length) {
          if (existHotel[0].selected == true) {
            hotel['selected'] = true;
          } else {
            hotel['selected'] = false;
          }
        } else {
          hotel['selected'] = false;
        }
      })
      this.setState({
        hotelsListFromWeb: hotelsData,
        isAdvanceSearch: true,
        isLoading: false
      })
    });
  }
  formatSelectedHotel(hotelData) {
    let placeId = hotelData.hotel.place_id;
    let hotelsList = this.state.hotelsListFromWeb;
    for (let i = 0; i < hotelsList.length; i++) {
      if (hotelsList[i].place_id == placeId) {
        hotelsList[i].selected = hotelData.selected;
        return
      }
    }
    this.setState({
      hotelsListFromWeb: hotelsList
    })
  }
  handleSearchTypeChange = (event) => {
    const selectedSearchType = event.target.value;
    this.setState({
      searchType: selectedSearchType,
      hotelPlaceFlag: false,
      isAdvanceSearch: false
    });
    if (this.state.searchType !== 'place') {
      this.setState({
        placeName: '', // Resetting the placeName state value
        radiusInMeter:'', // Resetting the radiusInMeter state value
        radiusType:''
      });
    }
    if (this.state.searchType !== 'name') {
      this.setState({
        search: ''
      })
    }
  }
  updateCounterLength = (newCounterLength) => {
    this.setState({ counterLength: newCounterLength });
  }


  hotelSearchByPlace() {
    let isValidSearchText = this.state.placeName ? true : false
    let isradiusType = this.state.radiusInMeter ? true : false
    if (!isValidSearchText || !isradiusType) {
      alert("Please enter search text");
      return
    }
    let payload = {
      eventId: this.props.event.event.id,
      searchTerm: this.state.placeName,
      rediusValue: this.state.radiusInMeter,
      rediusType:this.state.radiusType
    }
    this.setState({
      isLoading: true,
      searchFromWebBtnColor: "success",
      searchBtnColor: "default"
    })
    this.props.requestHotelByPlaces(payload, (response) => {
      let hotelsData = response.newhotels;
      let eventPosition = response.position_coordinates;
      hotelsData.forEach((hotel) => {
        let hotelLocation = hotel.geometry.location;
        let distance = this.getDistance(eventPosition.lat, eventPosition.lng, hotelLocation.lat, hotelLocation.lng, "K")
        console.log(distance)
        hotel['distance'] = distance
        hotel['formatted_address'] = hotel.vicinity
        let existHotel = this.props.existingHotelsList.filter(function (exHotel) {
          return exHotel.google_place_id == hotel.place_id;

        });
        if (existHotel.length) {
          if (existHotel[0].selected == true) {
            hotel['selected'] = true;
          } else {
            hotel['selected'] = false;

          }
        } else {
          hotel['selected'] = false;
        }
      })
      this.setState({
        hotelsListFromWeb: hotelsData,
        hotelPlaceFlag: true,
        isLoading: false,
      })
    });

  }
  searchByRadius = (event) => {
    const val = event.target.value
    this.setState({
      radiusType: event.target.value
    })
    if(this.state.radiusType!=='miles'){
      this.setState({
        radiusInMeter:'',
        hotelPlaceFlag: false,
        isAdvanceSearch: false

      })
    }
    if(this.state.radiusType!=='km'){
      this.setState({
        radiusInMeter:'',
        hotelPlaceFlag: false,
        isAdvanceSearch: false
      })
    }
    console.log(this.state.radiusType)
  }


  render() {
    const hotelsExist = this.props.hotels.length > 0;
    return (
      <div id="hotelAddDetailPopup">
        <FormGroup controlId="hotel-find">
          {/* <ControlLabel>Search</ControlLabel><br /> */}
          <div className='Radio-btn'>
            <div className='Name-Radio-btn'>
              <input
                type="radio"
                name="searchType"
                value="name"
                checked={this.state.searchType == 'name'}
                onChange={this.handleSearchTypeChange}
              />&nbsp;<span>Hotel by Name</span><br />
            </div>
            <div className='Location-Radio-btn'>
              <input
                type="radio"
                name="searchType"
                value="place"
                checked={this.state.searchType == 'place'}
                onChange={this.handleSearchTypeChange}
              />&nbsp;<span>Hotel by Location/Venue</span>
            </div>
          </div>
          <div className={this.state.searchType === 'name' ? 'show' : 'hide'}>
            <FormControl
              type="text"
              name="search"
              onChange={this.handleChange}
              value={this.state.search}
              placeholder="Search for hotel by Name"
            /><br></br>
            <Button onClick={this.handleSearch} bsStyle={this.state.searchBtnColor}>Search</Button>&nbsp;&nbsp;
            <Button onClick={this.handleAdvanceSearch} bsStyle={this.state.searchFromWebBtnColor}>Search From Web</Button>
          </div>
          <div className={this.state.searchType === 'place' ? 'show' : 'hide'}>
            <FormControl
              className='form-text'
              type="text"
              name="search"
              onChange={this.handleChangeName}
              value={this.state.placeName}
              placeholder="Search for hotel by Location/Venue"
            />
            <div>
              <div className='Name-Radio-btn'>
                <input
                  type="radio"
                  name="searchTypeRadius"
                  value="km"
                  checked={this.state.radiusType == 'km'}
                  onChange={this.searchByRadius}
                />&nbsp;<span>Search by Kilometer</span>&emsp;
                <input
                  type="radio"
                  name="searchTypeRadius"
                  value="miles"
                  checked={this.state.radiusType == 'miles'}
                  onChange={this.searchByRadius}
                />&nbsp;<span>Search by Miles</span>
              </div>
            </div>
            <div>
              <div className={this.state.radiusType === 'miles' ? 'show' : 'hide'}>
                <FormControl
                  type="number"
                  name="search"
                  onChange={this.handleChangeRadius}
                  value={this.state.radiusInMeter}
                  placeholder="Radius in miles"
                />
              </div>
              <div className={this.state.radiusType === 'km' ? 'show' : 'hide'}>
                <FormControl
                  type="number"
                  name="search"
                  onChange={this.handleChangeRadius}
                  value={this.state.radiusInMeter}
                  placeholder="Radius in kilometers"
                />
              </div>
            </div>
            <br></br>
            {/* <Button onClick={this.handleSearch} bsStyle={this.state.searchBtnColor}>Search</Button>&nbsp;&nbsp; */}
            <Button onClick={this.hotelSearchByPlace} bsStyle={this.state.searchFromWebBtnColor}>Search From Web</Button>
          </div>

        </FormGroup>
        {(this.props.fetching || this.state.isLoading) && <Loading />}
        {this.state.searchfromDatabase && !this.state.isLoading && (
          <HotelList
            eventId={this.props.event.event.id}
            hotels={this.props.hotels}
            selectHotel={this.props.selectHotel}
            favoriteHotel={this.props.favoriteHotel}
            displayHotel={this.props.displayHotel}
            displayError={this.props.displayError}
            event={this.props.event}
            requestBidsets={this.props.requestBidsets}
            selectedTourId={this.props.event.selectedTourId}
            pageSize={10}
          />
        )}
        {this.state.isAdvanceSearch && !this.state.isLoading && (
          <WebHotelList
            eventId={this.props.event.event.id}
            hotels={this.state.hotelsListFromWeb}
            selectHotel={this.props.selectHotel}
            favoriteHotel={this.props.favoriteHotel}
            displayHotel={this.props.displayHotel}
            event={this.props.event}
            selectHotelFromWeb={this.props.selectHotelFromWeb}
            displayError={this.props.displayError}
            formatSelectedHotel={this.formatSelectedHotel}
          />
        )}
        {this.state.hotelPlaceFlag && this.state.hotelsListFromWeb.length > 0 && (
          <div>
            <WebHotelList
              eventId={this.props.event.event.id}
              hotels={this.state.hotelsListFromWeb}
              selectHotel={this.props.selectHotel}
              favoriteHotel={this.props.favoriteHotel}
              displayHotel={this.props.displayHotel}
              event={this.props.event}
              selectHotelFromWeb={this.props.selectHotelFromWeb}
              displayError={this.props.displayError}
              formatSelectedHotel={this.formatSelectedHotel}
            />
          </div>
        )}

      </div>
    );
  }
}

HotelAddDetail.propTypes = {
  hotels: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      features: PropTypes.arrayOf(PropTypes.object),
    })
  ),
  favoriteHotel: PropTypes.func.isRequired,
  selectHotel: PropTypes.func.isRequired,
  findHotels: PropTypes.func.isRequired,
  displayHotel: PropTypes.func.isRequired,

};

HotelAddDetail.defaultProps = {
  hotels: [],
};
export default HotelAddDetail;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelAddDetail.js